;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.showAll = (function () {
    const initialize = function () {
      $('.js-visualRow.slick-even').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnHover: false
      })

      $('.js-visualRow.slick-odd').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnHover: false,
        onInit: function (self) {
          self.autoPlayClear()
          self.paused = true
          setTimeout(function () {
            self.paused = false
            self.autoPlay()
          }, 5000)
        }
      })

      $('.js-lotRow.slick-0, .js-lotRow.slick-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnHover: false
      })

      $('.js-lotRow.slick-1, .js-lotRow.slick-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnHover: false,
        onInit: function (self) {
          self.autoPlayClear()
          self.paused = true
          setTimeout(function () {
            self.paused = false
            self.autoPlay()
          }, 5000)
        }
      })

      $('.js-mastheadSlick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        onInit: function (self) {
        }
      })

      $('.js-inspirationGrid').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        centerMode: true,
        touchMove: false,
        speed: 1000,
        centerPadding: '0px',
        variableWidth: true,
        arrows: true,
        dots: false
      })

      // for homepage inspiration rows
      $('.js-inspirationRow.first-row').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        swipeToSlide: true,
        initialSlide: 3,
        centerMode: true,
        touchMove: false,
        speed: 1000,
        centerPadding: '0px',
        variableWidth: true,
        arrows: true,
        appendArrows: $('.js-inspirationRow.first-row .slick-list'),
        responsive: [
          {
            breakpoint: 940, // 960,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              speed: 1000
            }
          },
          {
            breakpoint: 620, // 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              speed: 1000
            }
          }
        ]
      })

      $('.js-inspirationRow.second-row').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        swipeToSlide: true,
        initialSlide: 3,
        centerMode: true,
        touchMove: false,
        speed: 1000,
        centerPadding: '0px',
        variableWidth: true,
        arrows: true,
        appendArrows: $('.js-inspirationRow.second-row .slick-list'),
        responsive: [
          {
            breakpoint: 940, // 960,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              speed: 1000
            }
          },
          {
            breakpoint: 620, // 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              speed: 1000
            }
          }
        ]
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.showAll.initialize()
  })
}(jQuery, window))
